<template>
  <MainWrapper>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="spec-info">
              <div
                class="spec-img mb-30"
                :style="{ 'background-image': `url(${companyInfo.photo})` }"
              ></div>
              <h3 class="mb-10">{{ companyInfo.name }}</h3>
              <div class="rating-wrapper mb-30">
                <span>Рейтинг ({{ companyInfo.rating | rating }})</span>
                <star-rating
                  class="ml-10"
                  :rating="this.companyInfo.rating || 0"
                  :increment="0.01"
                  :star-size="20"
                  :read-only="true"
                  :show-rating="false"
                ></star-rating>
              </div>
              <span class="dark-body-text block mb-10">
                {{
                companyInfo.categories[0].name
                }}
              </span>
              <p v-html="companyInfo.short_info" class="gray-body-text mb-15"></p>
              <div class="spec-state mb-30">
                <div class="mr-15">
                  <div
                    class="state-circle mr-5"
                    :class="{ 'state-circle-red': !companyInfo.opened_now }"
                  ></div>
                  <span>
                    {{
                    companyInfo.opened_now ? "Сейчас открыто" : "Сейчас закрыто"
                    }}
                  </span>
                </div>
                <!--
                            <div>
                                <font-awesome-icon class="geo-icon mr-5" :icon="['fal', 'map-marker-alt']" style="color:#24CEDA" />
                                <span>г. Бишкек</span>
                            </div>
                -->
              </div>
              <!--
                        <div class="gray-line mb-30"></div>
                        <div class="mb-30" style="height:41px">
                            <div style="margin-top:-2px;float:right">
                                <div style="color:#000000;font-weight:bold;padding: 15px 0">Показать всех</div>
                            </div>
                            <div v-if="companyInfo.masters.count > 0 && companyInfo.masters.list[0]['photo']" :style="'position:absolute;width:41px;height:41px;background:#efefef url('+companyInfo.masters.list[0]['photo']+');background-size:cover;border-radius:20.5px;display:inline-block;margin-left:0'"></div>
                            <div v-if="companyInfo.masters.count > 1 && companyInfo.masters.list[1]['photo']" :style="'position:absolute;width:41px;height:41px;background:#efefef url('+companyInfo.masters.list[1]['photo']+');background-size:cover;border-radius:20.5px;display:inline-block;margin-left:20px'"></div>
                            <div v-if="companyInfo.masters.count > 2 && companyInfo.masters.list[2]['photo']" :style="'position:absolute;width:41px;height:41px;background:#efefef url('+companyInfo.masters.list[2]['photo']+');background-size:cover;border-radius:20.5px;display:inline-block;margin-left:40px'"></div>
                            <div style="display:inline-block;color:#000000;font-weight:bold;padding: 12px 0;margin-left:90px">Показать всех</div>
                            <div style="position:absolute;width:80px;height:41px;display:inline-block;margin-left:90px;line-height:41px;color:#828282">+{{ companyInfo.masters.count }}</div>
                        </div>
              -->
              <div class="gray-line mb-30"></div>
              <div class="mb-10">
                <div>
                  <font-awesome-icon
                    class="geo-icon mr-5"
                    :icon="['fal', 'clock']"
                    style="color:#24CEDA"
                  />
                  <span>Время работы</span>
                </div>
              </div>
              <div v-if="companyInfo.work_time_start && companyInfo.work_time_end" class="mb-15">
                <div class="dark-body-text">
                  {{
                  moment(companyInfo.work_time_start, "HH:mm:ss").format(
                  "HH:mm"
                  )
                  }}
                  -
                  {{
                  moment(companyInfo.work_time_end, "HH:mm:ss").format(
                  "HH:mm"
                  )
                  }}
                </div>
              </div>
              <div v-else class="mb-15">
                <div class="dark-body-text">Выходной</div>
              </div>
              <div class="mb-10">
                <div>
                  <font-awesome-icon
                    class="geo-icon mr-5"
                    :icon="['fal', 'map-marker-alt']"
                    style="color:#24CEDA"
                  />
                  <span>Адрес</span>
                </div>
              </div>
              <div class="mb-15">
                <div class="dark-body-text">{{ companyInfo.street_address.replace(/:::::/g, ", ") }}</div>
              </div>
              <div class="mb-10">
                <div>
                  <font-awesome-icon
                    class="geo-icon mr-5"
                    :icon="['fal', 'envelope']"
                    style="color:#24CEDA"
                  />
                  <span>Email</span>
                </div>
              </div>
              <div class="mb-15">
                <div class="dark-body-text">{{ companyInfo.email }}</div>
              </div>
              <div v-if="companyInfo.contacts" class="mb-10">
                <div>
                  <font-awesome-icon
                    class="geo-icon mr-5"
                    :icon="['fal', 'phone']"
                    style="color:#24CEDA"
                  />
                  <span>Контактные номера</span>
                </div>
              </div>
              <div v-if="companyInfo.contacts" class="mb-15">
                <div
                  class="dark-body-text"
                  v-for="tel in companyInfo.contacts"
                  :key="tel.id"
                >{{ tel.phone }}</div>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <!--
                    <div>
                        <div class="tab-title-panel-active mr-5">
                            <span class="dark-body-text">Информация</span>
                        </div>
                        <div class="tab-title-panel mr-5">
                            <span class="dark-body-text">Отзывы</span>
                        </div>
                    </div>
            -->
            <div class="white-panel spec-deep-info">
              <div class="container-fluid">
                <div class="row">
                  <div class="tabs mb-30">
                    <div
                      class="tab pb-15 mr-30 inline-block pointer"
                      :class="{ active: tab === 'info' }"
                      @click="tab = 'info'"
                    >
                      <h4>Информация</h4>
                    </div>
                    <div
                      class="tab pb-15 mr-30 inline-block pointer"
                      :class="{ active: tab === 'users' }"
                      @click="tab = 'users'"
                    >
                      <h4>Специалисты</h4>
                    </div>
                    <div
                      class="tab pb-15 mr-30 inline-block pointer"
                      :class="{ active: tab === 'servs' }"
                      @click="tab = 'servs'"
                    >
                      <h4>Оборудование</h4>
                    </div>
                    <div
                      class="tab pb-15 mr-30 inline-block pointer"
                      :class="{ active: tab === 'reviews' }"
                      @click="tab = 'reviews'"
                    >
                      <h4>Отзывы ({{ total }})</h4>
                    </div>
                    <div class="light-gray-line"></div>
                    <div
                      v-if="tab === 'reviews' && companyReviews.length > 0"
                      class="row mb-15 ml-15"
                    >
                      <div
                        v-for="(review, i) in companyReviews"
                        :key="i"
                        class="col-lg-8 no-p mb-15"
                      >
                        <span class="dark-body-text block mb-10 reviewer-name">
                          {{ review.full_name }}
                          <star-rating
                            :rating="review.rating"
                            :increment="1"
                            :star-size="15"
                            :read-only="true"
                            :show-rating="false"
                            class="review-star"
                          ></star-rating>
                        </span>
                        <p class="mb-10">{{ review.message }}</p>
                        <p style="color:#828282">{{ review.created_at }}</p>
                      </div>
                    </div>
                    <div class="row" v-if="tab === 2">
                      <div class="col-lg-12">
                        <Paginator
                          :pages="pages"
                          v-if="pages > 1"
                          :current="page"
                          @change-page="changePage"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tab === 'reviews'">
                  <div class="col-lg-8 no-p">
                    <span class="dark-body-text block mb-10">Оставить отзыв</span>
                    <textarea
                      v-model="comment"
                      style="width:100%;height:160px;border-radius:8px;border:1px solid #E0E0E0"
                    ></textarea>
                    <span class="dark-body-text block mt-15 mb-10">Дайте свою оценку учреждению</span>
                    <RatingStar
                      :title="firstTitle"
                      :significant="true"
                      :rating="this.rateState.first.rating"
                      :isEmpty="this.rateState.first.isEmpty"
                      @setRate="firstHandler"
                    />
                    <RatingStar
                      :title="secondTitle"
                      :significant="true"
                      :rating="this.rateState.second.rating"
                      :isEmpty="this.rateState.second.isEmpty"
                      @setRate="secondHandler"
                    />
                    <RatingStar
                      :title="thirdTitle"
                      :significant="false"
                      :rating="this.rateState.third.rating"
                      :isEmpty="this.rateState.third.isEmpty"
                      @setRate="thirdHandler"
                    />
                    <div class="button-wrapper mt-30">
                      <Button type="gray" text="Сохранить" @click="setComment" />
                    </div>
                  </div>
                </div>
                <div v-if="tab === 'info'">
                  <div class="row mb-30">
                    <div class="col-lg-8 no-p">
                      <span class="dark-body-text block mb-10">О компании</span>
                      <p v-html="companyInfo.full_info" class="half-hide"></p>
                      <span class="more" @click="moreText">Еще...</span>
                    </div>
                  </div>
                  <div v-if="companyInfo.certificate.length > 0" class="row mb-30">
                    <div class="col-lg-12 no-p">
                      <span class="dark-body-text block mb-10">Сертификаты</span>
                      <div class="mb-15">
                        <div
                          class="mr-15"
                          v-for="(s, i) in companyInfo.certificate"
                          :key="i"
                          style="display:inline-block"
                        >
                          <a :href="s.url" target="_blank">
                            <img style="height:170px" :src="s.url" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="companyInfo.portfolio.length > 0" class="row mb-30">
                    <div class="col-lg-12 no-p">
                      <span class="dark-body-text block mb-10">Портфолио</span>
                      <div class="mb-15">
                        <div
                          class="mr-15"
                          v-for="(p, i) in companyInfo.portfolio"
                          :key="i"
                          style="display:inline-block"
                        >
                          <a :href="p.url" target="_blank">
                            <img style="height:170px" :src="p.url" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      companyInfo.latitude !== '' ||
                        companyInfo.longitude !== ''
                    "
                    class="row"
                  >
                    <div class="col-lg-12 no-p">
                      <span class="dark-body-text block mb-10">Адрес</span>
                    </div>
                  </div>
                  <div
                    v-if="
                      companyInfo.latitude !== '' ||
                        companyInfo.longitude !== ''
                    "
                    class="row mb-30"
                  >
                    <!-- lat:42.8717873, lng:74.6131377 -->
                    <GmapMap
                      :center="{
                        lat: companyInfo.latitude,
                        lng: companyInfo.longitude
                      }"
                      :zoom="17"
                      map-type-id="terrain"
                      style="width: 100%; height: 300px"
                    >
                      <GmapMarker
                        :position="{
                          lat: companyInfo.latitude,
                          lng: companyInfo.longitude
                        }"
                      />
                    </GmapMap>
                  </div>
                </div>
                <div v-if="tab === 'users'">
                  <div class="row" style="background: #efefef;padding-top: 20px">
                    <div>
                      <h3 class="black-text text-center mb-15">Поиск специалиста в компании</h3>
                      <div class="mb-30 text-center">
                        <div class="spec-search-wrapper inline-block">
                          <font-awesome-icon class="spec-search-icon" :icon="['far', 'search']" />
                          <input
                            class="rounded-input spec-search"
                            v-model="search"
                            @change="getSpecialists"
                            placeholder="Поиск специалиста по учреждению"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6" v-for="spec in specialists" :key="spec.id">
                      <Specialist
                        :name="spec.full_name"
                        :rating="spec.rating"
                        :cats="spec.categories"
                        :desc="spec.short_info"
                        :state="false"
                        :address="'г. Бишкек'"
                        :img="spec.photo"
                        :slug="spec.slug"
                        :status="spec.opened_now"
                        :reviewCount="spec.feeds_count"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="tab === 'servs'">
                  <div class="row" style="background: #efefef;padding-top: 20px">
                    <div class="col-lg-6" v-for="serv in services" :key="serv.id">
                      <Specialist
                        :name="serv.full_name"
                        :rating="serv.rating"
                        :cats="serv.categories"
                        :desc="serv.short_info"
                        :state="false"
                        :address="'г. Бишкек'"
                        :img="serv.photo"
                        :slug="serv.slug"
                        :reviewCount="spec.feeds_count"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.spec-img {
  background: #fff;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  background-size: cover;
  background-position: center;
}

.spec-deep-info {
  padding: 20px;
  overflow: hidden;
}

// .schedule-panel
// overflow: hidden
.tab {
  margin-bottom: -1px;
  transition: 0.3s;
  border-bottom: 1px solid transparent;
}

.tab.active {
  border-bottom: 1px solid cyan_dark_color;
}

.single-master-filters {
  display: flex;
  align-items: center;

  >div {
    display: flex;
    align-items: center;
  }
}

.schedule-controls {
  display: flex;
  align-items: center;

  .live-query-button-wrapper {
    margin: 0 0 0 auto;
  }
}

.input-wrapper {
  input {
    padding: 10px 15px;
  }
}

.tab-title-panel {
  display: inline-block;
  padding: 5px 30px;
  background: #E0E0E0;
  border-radius: 4px 4px 0 0;
  vertical-align: bottom;
  cursor: pointer;
}

.tab-title-panel-active {
  display: inline-block;
  padding: 10px 30px;
  /* background: radial-gradient(101.33px at 77.85% 86.89%, #1BEFDC 0%, #24CEDA 100%) */
  background: #ffffff;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
}

.spec-search-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 15px;
  color: #d2d2d2;
}

.spec-search {
  width: 420px;
  padding: 9px 15px 10px 40px;
}

@media screen and (max-width: 624px) {
  .tabs {
    .tab {
      padding: 5px 0 8px 0 !important;
    }
  }

  .half-hide {
    position: relative;
    height: 92px;
    overflow: hidden;
  }

  .more {
    position: absolute;
    right: 0;
    font-size: 16px;
    color: #3e3e3e;
    font-weight: 600;
    cursor: pointer;
  }

  .norm {
    height: 100%;
  }

  @media screen and (max-width: 528px) {
    .spec-search {
      width: 100%;
    }
  }
}
</style>
<script>
import { Component, Vue } from "vue-property-decorator";
import StarRating from "vue-star-rating";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import * as VueGoogleMaps from "vue2-google-maps";
import moment from "moment";
import http from "@/methods/http.ts";
import Specialist from "@/components/Specialist.vue";
import RatingStar from "@/components/RatingStar";

@Component({
  components: {
    MainWrapper,
    Button,
    Specialist,
    StarRating,
    RatingStar,
  },
  filters: {
    rating(value) {
      return value ? value.toFixed(1) : 0;
    },
  },
})
export default class SingleCompany extends Vue {
  tab = "info";

  specModal = false;

  moment = moment;

  firstDay = moment().format("DD.MM.YYYY");

  week = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  companyInfo = {
    rating: 0,
    categories: [],
  };

  specialists = [];
  services = [];

  search = "";

  companyReviews = [];

  comment = "";
  firstTitle = "Качество обслуживания";
  secondTitle = "Ценовая политика";
  thirdTitle = "Компетентность специалиста";

  rateState = {
    overall: 0,
    first: {
      set: false,
      value: 0,
      rating: 0,
      isEmpty: false,
    },
    second: {
      set: false,
      value: 0,
      rating: 0,
      isEmpty: false,
    },
    third: {
      set: false,
      value: 0,
      rating: 0,
      isEmpty: false,
    },
  };

  total = 0;
  pages = 0;
  page = 1;
  itemPerPage = 5;

  nextWeek() {
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .add(7, "d")
      .format("DD.MM.YYYY");
  }

  prevWeek() {
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .subtract(7, "d")
      .format("DD.MM.YYYY");
  }

  getSpecialists() {
    http("masters", "get", false, {
      page: 1,
      org_id: this.companyInfo.id,
      page_size: 100,
      whois: "user",
      search: this.search,
      //categories: this.chosenChildCategory || this.chosenCategory || undefined,
    }).then((r) => {
      this.specialists = r.data.results;
      //this.pages = Math.ceil(r.data.count / 10);
      //this.specCount = r.data.count;
    });
  }

  getServices() {
    http("masters", "get", false, {
      page: 1,
      org_id: this.companyInfo.id,
      page_size: 12,
      whois: "serv",
      //search: this.search,
      //categories: this.chosenChildCategory || this.chosenCategory || undefined,
    }).then((r) => {
      this.services = r.data.results;
      //this.pages = Math.ceil(r.data.count / 10);
      //this.specCount = r.data.count;
    });
  }

  getCompanyInfo() {
    http(`companies/${this.$route.params.slug}`, "get", false, {}).then((r) => {
      this.companyInfo = r.data;
      let work_time = this.companyInfo.times.find(
        (i) => i.week_day === this.week[moment().weekday()]
      );
      console.log(this.week[moment().weekday()]);
      //let work_time = this.companyInfo.times.find(i => i.week_day === this.week[3]);
      if (work_time) {
        this.companyInfo.work_time_start = work_time.time.start_time;
        this.companyInfo.work_time_end = work_time.time.end_time;
        let start_time = work_time.time.start_time;
        let end_time = work_time.time.end_time;
        let current_time = moment().format("HH:mm");
        start_time = start_time.replace(":", "");
        end_time = end_time.replace(":", "");
        current_time = current_time.replace(":", "");
        start_time =
          start_time.indexOf("0") == 0 ? start_time.substring(1) : start_time;
        end_time =
          end_time.indexOf("0") == 0 ? end_time.substring(1) : end_time;
        current_time =
          current_time.indexOf("0") == 0
            ? current_time.substring(1)
            : current_time;
        //console.log(start_time+'-'+end_time+'-'+current_time);
        if (
          parseInt(current_time) > parseInt(start_time) &&
          parseInt(current_time) < parseInt(end_time)
        ) {
          this.companyInfo.opened_now = true;
        }
      }
      this.getSpecialists();
      this.getServices();
    });
  }

  getCompanyReviews() {
    moment.lang("ru");
    let review_list = [];
    http(`companies/${this.$route.params.slug}/rating`, "get", false, {
      page: this.page,
      limit: this.itemPerPage,
    }).then((r) => {
      console.log("reviews", r);
      this.total = r.data.total;
      review_list = r.data.list;
      if (review_list.length > 0) {
        review_list.forEach(function (elm) {
          elm.created_at = moment
            .unix(parseInt(elm.date))
            .format("DD MMMM YYYY");
        });
      }
      console.log("review_list", review_list);
      this.pages = Math.ceil(r.data.total / this.itemPerPage);
      this.companyReviews = review_list;
    });
  }

  setComment() {
    if (this.comment === "") {
      this.$store.commit("notificate", {
        text: "Напишите отзыв",
        type: "error",
      });
      return false;
    } else if (this.rateState.overall === 0) {
      this.$store.commit("notificate", {
        text: "Поставьте оценки",
        type: "error",
      });
      return false;
    }
    http("companies/rating/create", "post", this.$store.state.token, {
      com_id: this.companyInfo.id,
      message: this.comment,
      rating: this.rateState.overall,
    })
      .then((r) => {
        this.comment = "";
        this.$store.commit("notificate", {
          text: "Отзыв добавлен",
          type: "action",
        });
        this.clearRating();
      })
      .catch((r) => {
        this.$store.commit("notificate", {
          text: "Введены неверные данные",
          type: "error",
        });
      });
  }

  firstHandler({ majorRating, rating }) {
    const type = "first";
    this.calculateRate(majorRating, type);
    this.rateState[type].set = true;
    this.rateState[type].value = majorRating;
    this.rateState[type].rating = rating;
  }

  secondHandler({ majorRating, rating }) {
    const type = "second";
    this.calculateRate(majorRating, type);
    this.rateState[type].set = true;
    this.rateState[type].value = majorRating;
    this.rateState[type].rating = rating;
  }

  thirdHandler({ majorRating, rating }) {
    const type = "third";
    this.calculateRate(majorRating, type);
    this.rateState[type].set = true;
    this.rateState[type].value = majorRating;
    this.rateState[type].rating = rating;
  }

  calculateRate(rate, type) {
    if (this.rateState[type].set) {
      this.rateState.overall -= this.rateState[type].value;
      this.rateState.overall += rate;
    } else {
      this.rateState.overall += rate;
    }
    console.group("RATE");
    console.log(this.rateState);
    console.groupEnd();
  }

  clearRating() {
    Object.keys(this.rateState).map((k) => {
      if (k !== "overall") {
        this.rateState[k].isEmpty = true;
        this.rateState[k].rating = 0;
      }
    });
    console.log("rateState", this.rateState);
  }

  changePage(p) {
    this.page = p;
  }

  moreText() {
    let more = document.querySelector(".half-hide");
    let moreBtn = document.querySelector(".more");
    more.classList.toggle("norm");
    if (more.classList.contains("norm")) {
      moreBtn.style.display = "none";
    }

    // more.style.height = "100%";
  }
  mounted() {
    this.getCompanyInfo();
    this.getCompanyReviews();
  }
}
</script>
